"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.parse-int.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSensorContext = exports["default"] = exports.SensorProvider = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// import
require("./styles/sensor.less");

var styles = {
  "screenSmMax": "767px",
  "screenMdMax": "991px"
}; // typescript definition

// definition
var SensorContext = /*#__PURE__*/_react["default"].createContext({
  isMobile: false,
  isTablet: false,
  isDesktop: false
});

var SensorProvider = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var children = _ref.children;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isMobile = _useState2[0],
      setIsMobile = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      isTablet = _useState4[0],
      setIsTablet = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      isDesktop = _useState6[0],
      setIsDesktop = _useState6[1];

  var value = (0, _react.useMemo)(function () {
    return {
      isMobile: isMobile,
      isTablet: isTablet,
      isDesktop: isDesktop
    };
  }, [isMobile, isTablet, isDesktop]);
  (0, _react.useEffect)(function () {
    var resize = function resize() {
      var mobileQuery = window.matchMedia("(max-width: ".concat(styles.screenSmMax, ")"));
      var tabletQuery = window.matchMedia("(min-width: ".concat(parseInt(styles.screenSmMax, 10) + 1, "px) and (max-width: ").concat(styles.screenMdMax, ")"));
      setIsMobile(mobileQuery.matches);
      setIsTablet(tabletQuery.matches);
      setIsDesktop(!mobileQuery.matches && !tabletQuery.matches);
    };

    resize();
    window.addEventListener('resize', resize);
    return function () {
      window.removeEventListener('resize', resize);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement(SensorContext.Provider, {
    value: value
  }, children);
});

exports.SensorProvider = SensorProvider;
var _default = SensorContext;
exports["default"] = _default;

var useSensorContext = function useSensorContext() {
  var sensorContextValue = (0, _react.useContext)(SensorContext);

  if (sensorContextValue === undefined) {
    throw new Error('useSensorContext must be used within a SensorProvider');
  }

  var isMobile = sensorContextValue.isMobile,
      isTablet = sensorContextValue.isTablet,
      isDesktop = sensorContextValue.isDesktop;
  return {
    isMobile: isMobile,
    isTablet: isTablet,
    isDesktop: isDesktop
  };
};

exports.useSensorContext = useSensorContext;